import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, TextField, Box, Checkbox } from '@mui/material';

const PresetFieldGroup = ({ field, presetForm, handleChange, handleProfilesChange, getProfileDisplayName }) => {
  const renderField = () => {
    switch (field.type) {
      case 'text':
      case 'number':
        return (
          <TextField
            type={field.type}
            label={field.label}
            value={presetForm[field.name] || (field.type === 'number' ? 0 : '')}
            onChange={handleChange(field.name)}
            fullWidth
            size="small"
            multiline={field.multiline}
            rows={field.rows}
          />
        );
      case 'switch':
        return (
          <FormControlLabel
            control={<Switch checked={!!presetForm[field.name]} onChange={handleChange(field.name)} />}
            label={field.label}
          />
        );
      case 'select':
        return (
          <FormControl fullWidth size="small">
            <InputLabel>{field.label}</InputLabel>
            <Select value={presetForm[field.name] || ''} onChange={handleChange(field.name)}>
              {field.includeNone && <MenuItem value="">None</MenuItem>}
              {field.options.map(option => (
                <MenuItem key={typeof option === 'string' ? option : option.value} value={typeof option === 'string' ? option : option.value}>
                  {typeof option === 'string' ? option : option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case 'profiles':
        return (
          <FormControl fullWidth size="small">
            <InputLabel>{field.label}</InputLabel>
            <Select
              multiple
              value={presetForm[field.name] ? presetForm[field.name].split(',').filter(Boolean).map(String) : []}
              onChange={handleProfilesChange(field.name)}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.length === 0 ? (
                    <Box sx={{ color: 'text.secondary' }}>All</Box>
                  ) : (
                    selected.map(id => (
                      <Box key={id} sx={{ display: 'inline-flex', alignItems: 'center', mr: 0.5 }}>
                        {getProfileDisplayName(id)}
                      </Box>
                    ))
                  )}
                </Box>
              )}
            >
              <MenuItem value="">
                <Checkbox checked={!presetForm[field.name]} />
                <em>All</em>
              </MenuItem>
              {field.options.map(p => (
                <MenuItem key={p.id} value={String(p.id)}>
                  <Checkbox checked={presetForm[field.name]?.split(',').includes(String(p.id))} />
                  {getProfileDisplayName(p.id)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case 'dealerships':
        return (
          <FormControl fullWidth>
            <InputLabel>{field.label}</InputLabel>
            <Select
              multiple
              value={field.value}
              onChange={field.onChange}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.length === 0 ? (
                    <Box sx={{ color: 'text.secondary' }}>All</Box>
                  ) : (
                    selected.map(subdomain => {
                      const inst = field.options.find(i => i.subdomain === subdomain);
                      return (
                        <Box key={subdomain} sx={{ display: 'inline-flex', alignItems: 'center', mr: 0.5 }}>
                          {inst?.softname || subdomain}
                        </Box>
                      );
                    })
                  )}
                </Box>
              )}
            >
              {field.options.map(inst => (
                <MenuItem key={inst.subdomain} value={inst.subdomain}>
                  <Checkbox checked={field.value.includes(inst.subdomain)} />
                  {inst.softname || inst.subdomain}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      default:
        return null;
    }
  };

  return renderField();
};

export default PresetFieldGroup;